export default __webpack_public_path__ + "static/media/aithinking.c0df69c2.gif";